// do not change the order!
export const BROWSER_UA_SPECS = [
  'qq', // mobile QQ
  'mqqbrowser', // mobile QQBrowser
  'ucbrowser', // UCBrowser
  'baiduboxapp', // 手机百度
  'baiduspider', // Baidu spider
  'baidubrowser', // Baidu browser
  'micromessenger', // Weixin
  'weibo', // 微博
  'alipay', // 支付宝
  'discover', // XHSWebView 6.18+
  'redtop', // 友友视频WebView
  'uniik', // 国际化WebView
]

export function getBrowser(UA) {
  let browser = 'unspecified'
  let ua

  if (!process.env.BROWSER) {
    ua = UA.toLowerCase()
  } else {
    ua = (UA || window.navigator.userAgent).toLowerCase()
  }

  /*
   * 监测规则:
   * 1. 优先浏览器
   * 2. 具体应用覆盖
   *
   */

  browser = BROWSER_UA_SPECS.reduce((ret, name) => {
    if (ua.indexOf(name) >= 0) {
      ret = name // eslint-disable-line no-param-reassign
    }
    return ret
  }, browser)

  /*
   * 简单的附加逻辑
   * 如果是iOS或mac 返回safari
   * 如果是Window或Android 返回chrome
   */

  if (browser === 'unspecified') {
    if (ua.indexOf('iphone') >= 0 || ua.indexOf('macintosh') >= 0) {
      browser = 'safari'
    } else if (ua.indexOf('android') >= 0 || ua.indexOf('windows nt') >= 0) {
      browser = 'chrome'
    }
  }

  if (browser === 'mqqbrowser') {
    // qq 在android上同时有 MQQBrowser QQ 字段
    if (ua.indexOf('android') >= 0
      && /mqqbrowser/i.test(ua) && /qq/i.test(ua.replace('mqqbrowser', ''))) {
      browser = 'qq'
    }
  }

  return browser
}

export function getBrowserVersion(UA) {
  const version = {
    major: 0,
    minor: 0,
    patch: 0,
  }

  let ua

  if (!process.env.BROWSER) {
    ua = UA.toLowerCase()
  } else {
    ua = (UA || window.navigator.userAgent).toLowerCase()
  }

  /**
   * `XHS` for old XHS WebView
   * `Version` for new XHS WebView & Safari
   * `discover` for new XHSWebView: 6.18
   * `Chrome` for Chrome
   */
  let regex

  if (ua.includes('discover')) {
    regex = /(?:discover)\/(\d+)\.(\d+)\.?(\d+)?/
  } else {
    regex = /(?:XHS|Version|Chrome)\/(\d+)\.(\d+)\.?(\d+)?/
  }
  const result = regex.exec(ua)

  if (result) {
    version.major = parseInt(result[1], 10)
    version.minor = parseInt(result[2], 10)

    if (result[3] !== undefined) {
      version.patch = parseInt(result[3], 10)
    }
  }

  return version
}
